/**
 * Created by rickborst on 16/06/2017.
 */

import _ from 'lodash';

/**
 * Validator fo the authentication response.
 *
 * @param {Object} response - Authentication response.
 * @returns {boolean} Whether the response is valid or not.
 */
export function isValidResponse (response) {

    return !_.get(response, ['result', 'error']);
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/validators/config.js